var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternUnits: "userSpaceOnUse",
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1b272f",
    cx: 1,
    cy: 1,
    r: 0.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h700v700H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1b272f",
    transform: "matrix(.8 0 0 .8 70 70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 499,
    cy: 560,
    r: 70,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499,
    cy: 560,
    r: 47,
    fill: "#1b272f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503,
    cy: 651,
    r: 24.5,
    fill: "none",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503,
    cy: 651,
    r: 7,
    fill: "#1b272f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621,
    cy: 438,
    r: 39.5,
    fill: "none",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621,
    cy: 438,
    r: 15,
    fill: "#1b272f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 64,
    r: 32,
    fill: "none",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 64,
    r: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 399,
    r: 102.5,
    fill: "none",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m499 560 4 91 118-213L405 64l90 335"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.aae05d3d9cf5963be9a268c65599ebba.svg";
export { ForwardRef as ReactComponent };